import type { OktaUser } from '../context';

export const SPORTYBOT_GROUP = {
  ADMIN: 'Sportybot Web Admin',
  LEAGUE_MANAGER: 'Sportybot Web League Manager',
  LEAGUE_USER: 'Sportybot Web League User',
  MILB_CLUB_MANAGER: 'Sportybot Web MiLB Club Manager',
  MILB_CLUB_USER: 'Sportybot Web MiLB Club User',
  MLB_CLUB_MANAGER: 'Sportybot Web MLB Club Manager',
  MLB_CLUB_USER: 'Sportybot Web MLB Club User',
} as const;

export type Action =
  | 'CAN_ACCESS_RULES'
  | 'CAN_COPY_ACCESS_TOKEN'
  | 'CAN_VIEW_ALL_RULES'
  | 'CAN_VIEW_ALL_SPORTS';

export type SportybotGroup = (typeof SPORTYBOT_GROUP)[keyof typeof SPORTYBOT_GROUP];

const { ADMIN, LEAGUE_MANAGER, LEAGUE_USER, MILB_CLUB_MANAGER, MLB_CLUB_MANAGER, MLB_CLUB_USER } =
  SPORTYBOT_GROUP;

const groupsByAction: Record<Action, SportybotGroup[]> = {
  CAN_ACCESS_RULES: [ADMIN, LEAGUE_MANAGER, MILB_CLUB_MANAGER, MLB_CLUB_MANAGER],
  CAN_COPY_ACCESS_TOKEN: [ADMIN],
  CAN_VIEW_ALL_RULES: [ADMIN],
  CAN_VIEW_ALL_SPORTS: [ADMIN, LEAGUE_MANAGER, LEAGUE_USER, MLB_CLUB_MANAGER, MLB_CLUB_USER],
};

export function can(user: Pick<OktaUser, 'groups'>, action: Action): boolean {
  return user.groups.some((group) => groupsByAction[action].includes(group));
}
